import { useState, useRef, useEffect, memo } from "react";
import axios from "axios";

const Video_check_time = memo(
  ({ row }) => {
    const videoRef = useRef(null);
    const [duration, setDuration] = useState(null);
    const [videoSrc, setVideoSrc] = useState(null); // blob local

    useEffect(() => {
      let isMounted = true;
      let objectURL = null;

      const fetchVideo = async () => {
        try {
          console.log("📥 Fetch video:", row.url_videos);
          const res = await axios.get(row.url_videos, {
            responseType: "blob",
            timeout: 30000,
          });
          objectURL = URL.createObjectURL(res.data);
          if (isMounted) setVideoSrc(objectURL);
        } catch (err) {
          console.error("❌ Lỗi tải video:", err.message || err);
        }
      };

      fetchVideo();

      return () => {
        isMounted = false;
        if (objectURL) URL.revokeObjectURL(objectURL);
      };
    }, [row.url_videos]);

    useEffect(() => {
      const video = videoRef.current;
      if (!video) return;

      const handleLoaded = () => {
        setDuration(video.duration);
        console.log("🎬 Video metadata loaded:", row.url_videos);
      };

      video.addEventListener("loadedmetadata", handleLoaded, { once: true });
      return () => video.removeEventListener("loadedmetadata", handleLoaded);
    }, [videoSrc]);

    const formatTime = (seconds) => {
      if (!seconds || isNaN(seconds)) return "0:00";
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60);
      return `${m}:${s.toString().padStart(2, "0")}`;
    };

    return (
      <>
        {/* Cột video */}
        <td className="border text-center py-2">
          {videoSrc ? (
            <video
              ref={videoRef}
              src={videoSrc}
              controls
              preload="metadata"
              className="mx-auto max-w-full h-auto max-h-[350px]"
            />
          ) : (
            <div className="text-gray-500 italic">⏳ Đang tải video...</div>
          )}
        </td>

        {/* Cột note + info */}
        <td className="border text-center py-2">
          <div className="mb-1">{row.note}</div>
          {duration !== null && <div className="text-sm">⏱ {formatTime(duration)}</div>}
          <div>{row.worker?.[0]?.media_link_url}</div>
          <div>{row.worker?.[0]?.media_link_phone}</div>
        </td>
      </>
    );
  },
  (prev, next) => prev.row.url_videos === next.row.url_videos
);

export default Video_check_time;
